export default __webpack_public_path__ + "static/media/TerisaLovelace.8ca64355.png";